import { getDefaultNamePartsForEmail, getCanonicalEmail, buildFullName } from './userProfiles';

export function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function getStoredToken() {
  return localStorage.getItem('token');
}

export function getAuthPayload() {
  const token = getStoredToken();
  return token ? decodeToken(token) : null;
}

export function getUserRoles(payload = getAuthPayload()) {
  if (!payload) return [];

  return Array.isArray(payload.roles)
    ? payload.roles
    : [payload.role].filter(Boolean);
}

export function getUserEmail(payload = getAuthPayload()) {
  return getCanonicalEmail(payload?.email || '') || 'User';
}

export function getUserDisplayName(payload = getAuthPayload()) {
  if (!payload) return 'User';
  const fallback = getDefaultNamePartsForEmail(payload.email) || {};
  const firstName = String(payload.firstName || fallback.firstName || '').trim();
  const lastName = String(payload.lastName || fallback.lastName || '').trim();
  return String(payload.fullName || '').trim() || buildFullName(firstName, lastName) || getUserEmail(payload);
}

export function isTokenExpired(payload = getAuthPayload()) {
  return Boolean(payload?.exp && payload.exp * 1000 <= Date.now());
}
